import React, { useEffect, useState, useRef, LegacyRef, useCallback } from 'react'
import { ProgressBarComponent } from '@syncfusion/ej2-react-progressbar';
import { Tile } from './Tile'
import './SelectionGrid.scss'
import { LibraryTraceCrumb } from './types/ThirdPartyLibrary'
import { FetchState } from './FetchState'
import { UploadTile } from './UploadTile';
// import { registerLicense } from '@syncfusion/ej2-base';

export const satisfiesFilter = (filters:any[]=[], tile:any)=>{
    let isSatisfied = true;
    filters.forEach(filter=>{
        if(!(tile.filter && tile.filter[filter.filterKey] && tile.filter[filter.filterKey].includes(filter.filterValue))){
            isSatisfied = isSatisfied && false
        }
    })
    return isSatisfied
}

interface SelectionGridProps{

    goBack:()=>void
    showUploadTile: boolean,
    progressState?: {
        result?: 'success' | 'failure',
        inProgress?: boolean,
        displayMesssage?: string
    }
    filters:{filterKey:string,filterValue:string}[],
    crumb?: LibraryTraceCrumb,
    tiles: { isPatternImage:boolean, url: string, thumbnail: string, name: string, isCategory: boolean, id: number, containsPatterns: boolean, isLastElement?: boolean, scaleFactor:number }[]
    fetchPatterns: (category: LibraryTraceCrumb, pageRequested: number) => void
    uploadImage: (url: string, id: number, name: string, isPatternDesign:boolean, scaleFactor:number) => void,
    wizardScreen?:()=>void
}

export const SelectionGrid = React.forwardRef((props:SelectionGridProps, ref:any)=>{
    const { progressState, tiles, goBack, crumb, showUploadTile, filters } = props

    const selectionGrid = useRef(null as HTMLDivElement | null)
    const currrentPageNumber = useRef(0);
    const inProgress = useRef(progressState?.inProgress || false)
    const [pageNumber, setPageNumber] = useState(0);
    const isLastPage = useRef(false);
    const tileRef = useRef(null as HTMLElement|null);

    // registerLicense('Mgo+DSMBaFt+QHJqUE1hXk5Hd0BLVGpAblJ3T2ZQdVt5ZDU7a15RRnVfR1xqSXlXcEZkUXpYeA==;Mgo+DSMBPh8sVXJ1S0R+WVpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF5jTH9adkJnX3xZeHNUTg==;ORg4AjUWIQA/Gnt2VFhiQlRPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXtSf0VkXXldd3xdQ2g=;MjExNTY2MUAzMjMxMmUzMjJlMzVKR3pvd2pDN1VPbTlEdE81WHVOeE5WaGFtZ25RN3hSTTFBVlZqdHoxZkRnPQ==;MjExNTY2MkAzMjMxMmUzMjJlMzVYbXBackFZaE1tSnBUZEYyOTNDM3JFMVhGbldWSDliTlFLaHlFcDBBczJZPQ==;NRAiBiAaIQQuGjN/V0d+Xk9BfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5Wd0xjXntYc3NcQGZU;MjExNTY2NEAzMjMxMmUzMjJlMzVvTE93a1dFK2tRWmJ5aU5naEh5bDY1Qk5EUW5zVjh0YWt2Ni8zekpiVkpFPQ==;MjExNTY2NUAzMjMxMmUzMjJlMzVEZXhMNk9NVE14ekxMZjF2ZU1JR1ZmendlbnNHamJCUnVKUG1RYzhWUHZRPQ==;Mgo+DSMBMAY9C3t2VFhiQlRPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXtSf0VkXXldeHRRRWg=;MjExNTY2N0AzMjMxMmUzMjJlMzVCbUZKeVJ4R2VlMTkvekg0UWpJS1M0MERLaVJXa3hZU1F6c0NyY0gwZ0NrPQ==;MjExNTY2OEAzMjMxMmUzMjJlMzVWVEV3Z2xVMUZ1TTBjR29oSWlSNFBoSzNNS21BZzhIbDZVL0ZjVmhmd1A4PQ==;MjExNTY2OUAzMjMxMmUzMjJlMzVvTE93a1dFK2tRWmJ5aU5naEh5bDY1Qk5EUW5zVjh0YWt2Ni8zekpiVkpFPQ==');


    inProgress.current = progressState?.inProgress || false
    const increment = useRef(0);

    useEffect(() => {
        if (crumb) {
            props.fetchPatterns(crumb, pageNumber)
        }
        currrentPageNumber.current = pageNumber
    }, [pageNumber, crumb])

    useEffect(() => {
        setPageNumber(0)
    }, [crumb?.id])

    useEffect(() => {
            const offsetHeight = selectionGrid.current?.offsetHeight || 0;
        if(tileRef.current && (tileRef.current.getBoundingClientRect().bottom <= offsetHeight)){
            setPageNumber(pageNumber+1);
        }
    },[tileRef.current])

    const scrollHandler = useCallback(()=>{
        const gridBottom = Math.ceil((selectionGrid.current?.getBoundingClientRect().bottom)||0)//(selectionGrid.current?.scrollTop || 0) + (selectionGrid.current?.offsetHeight || 0);
        const lastTileBottom = Math.floor(tileRef.current && (tileRef.current.getBoundingClientRect().bottom)||0)
        const isLastTileBottomReached = (lastTileBottom <= gridBottom)
        if(isLastTileBottomReached && (!inProgress.current)){
            setPageNumber(currrentPageNumber.current+1)
        }
    },[])

    useEffect(() => {
        selectionGrid.current?.addEventListener('scroll', scrollHandler)

        return ()=>{
            selectionGrid.current?.removeEventListener('scroll',scrollHandler)
        }
    }, [selectionGrid.current])

    return <div className='grid-container'>
        
        <FetchState goBack={goBack} tilesCount={tiles && tiles.length} progress={progressState?.inProgress} result={progressState?.result}/>

        {tiles && tiles.length ? <div ref={selectionGrid} className={props.tiles[0].isCategory? 'selection-grid cat-selection-grid': 'selection-grid'} >
            {showUploadTile ? <UploadTile  wizardScreen={props.wizardScreen}/> : null}
            {props.tiles.filter(tile => tile.url).filter(tile => satisfiesFilter(filters, tile)).map((tile, index) => {
                isLastPage.current = !!(tile.isLastElement)
                let ref={}
                if(index === (tiles.length-1)){
                    ref = {ref: tileRef}
                }
                return <Tile {...ref} {...tile} key={tile.id} uploadImage={props.uploadImage} fetchPatterns={() => {
                props.fetchPatterns({
                    id: tile.id,
                    isCategory: tile.isCategory,
                    isPatternContainer: tile.containsPatterns,
                        name: tile.name,
                    }, 0);
            }} />
        })}
        </div> : null}
        {progressState?.inProgress ? <ProgressBarComponent type='Linear' isActive value={100} isIndeterminate animation={{
            enable: true,
            duration: 2000,
            delay: 0
        }} /> : null}
    </div>
})